var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_14",
    "data-name": "Artboard \\u2013 14",
    clipPath: "url(#clip-Artboard_14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-alt-circle-down",
    "data-name": "Icon awesome-arrow-alt-circle-down",
    d: "M25.675,13.119A12.556,12.556,0,1,1,13.119.563,12.554,12.554,0,0,1,25.675,13.119ZM10.891,7.246v5.873H7.3a.608.608,0,0,0-.43,1.038l5.817,5.787a.6.6,0,0,0,.856,0l5.817-5.787a.608.608,0,0,0-.43-1.038H15.347V7.246a.609.609,0,0,0-.608-.608H11.5A.609.609,0,0,0,10.891,7.246Z",
    transform: "translate(12.557 31.11) rotate(-135)",
    fill: "#f5d60d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUpRight);
export default __webpack_public_path__ + "static/media/iconArrowUpRight.d0c124e3aad1b6de4d9840d81b05d272.svg";
export { ForwardRef as ReactComponent };